import React from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { earningsEffects, earningsSelectors } from 'features/earnings/slice';

const NavIconWrap = styled.div`
  padding: 6px 4px;
  border-radius: 4px;
  cursor: pointer;
  :hover {
    background-color: ${color.gainsboro};
  }
`;
const QuarterNavigation = () => {
  const dispatch = useDispatch();

  const {
    earnings: { data },
  } = useSelector(earningsSelectors);

  const {
    quarter,
    year,
    prev_earnings_period: prevPeriod,
    next_earnings_period: nextPeriod,
    order,
    page,
    sortcol,
    keyword,
    filter,
  } = data;

  const getData = (q: any, y: any) => {
    dispatch(
      earningsEffects.getEarnings({
        year: y,
        quarter: q,
        order,
        page,
        sortcol,
        companySymbol: keyword || undefined,
        filter,
      }),
    );
  };

  const prevQuarterHandler = () => {
    const { quarter: prevQuarter, year: prevYear } = prevPeriod;

    getData(prevQuarter, prevYear);
  };

  const nextQuarterHandler = () => {
    const { quarter: nextQuarter, year: nextYear } = nextPeriod;
    if (nextQuarter) {
      getData(nextQuarter, nextYear);
      return;
    }

    getData(quarter, year);
  };

  return (
    // @ts-expect-error
    <Flex align="center" ml="auto">
      <NavIconWrap onClick={prevQuarterHandler}>
        <Iconmoon size="14px" className="icon-toolbar_prev" />
      </NavIconWrap>
      <Text width="70px" size="14px" align="center">
        {`Q${quarter || ' ...'}`} {year || ' ...'}
      </Text>
      {nextPeriod && (
        <NavIconWrap onClick={nextQuarterHandler}>
          <Iconmoon size="14px" className="icon-toolbar_next" />
        </NavIconWrap>
      )}
    </Flex>
  );
};

export default QuarterNavigation;
